<script lang="ts">
</script>

<div class="container">
  <div class="container-title">CxNxD Kings (V1)</div>
  <div class="container-content">
    <div class="sub-content">
      <img class="sample-img" src="/assets/v1.png" alt="sample" />
      <div class="sub-content-box">
        <div class="sub-content-title">About 'Clones Never Die Kings'</div>
        <div class="sub-content-paragraph">
          'Clones Never Die K' is version 1 of 'Clones Never Die'.
          <br />
          'CxNxD K' exists on the klaytn blockchain.
          <br />
          100 clones of the CxNxD Original Collection have been transferred to Polygon.
          <br />
          And it was made with a collection called Clones Never Die Kings.
          <br />
          Each clone is the king of the clone world and is named.
          <br />
          In addition, a black frame is attached to the existing original collection picture.
        </div>
      </div>
    </div>
    <div class="sub-content">
      <div class="sub-content-box-center">
        Opensea Collection
        <a class="sub-content-contract" href="https://opensea.io/collection/clones-never-die-kings" target="_blank"
          >Clones Never Die Kings (V1)</a
        >
      </div>
    </div>
    <div class="sub-content">
      <div class="sub-content-box-center">
        CxNxD Kings Contract Address
        <a
          class="sub-content-contract"
          href="https://scope.klaytn.com/nft/0x5893bfabee0f482f7b025171020cffe8ee9c0c66"
          target="_blank">0x5893BfabeE0f482f7B025171020CfFe8EE9C0c66</a
        >
      </div>
    </div>
  </div>
</div>
<hr class="divide-line" />

<style lang="scss">
  .container-content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  .sub-content {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 20px;
  }

  .sub-content-contract {
    font-size: 1rem;
    color: $highlight-color;
  }

  .sub-content-box {
    width: 50%;
    line-height: 24px;
    font-size: 18px;
    display: flex;
    flex-direction: column;
  }

  .sub-content-box-center {
    line-height: 24px;
    font-size: 18px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 30px;
  }

  .sub-content-title {
    font-size: 2rem;
    margin-bottom: 20px;
  }

  .sub-content-paragraph {
    width: 100%;
    line-height: 24px;
    font-size: 1rem;
  }

  .sample-img {
    width: 30%;
    border-radius: 10px;
    margin-bottom: 20px;
  }

  @media screen and (max-width: 768px) {
    .sub-content {
      width: 100%;
      display: flex;
      justify-content: space-around;
      flex-direction: column;
      align-items: center;
      margin-bottom: 20px;
    }

    .sub-content-contract {
      font-size: 0.8rem;
    }

    .sub-content-title {
      font-size: 1.5rem;
      margin-bottom: 20px;
    }

    .sub-content-box {
      width: 100%;
      line-height: 24px;
      font-size: 18px;
      display: flex;
      flex-direction: column;
    }

    .sub-content-paragraph {
      width: 100%;
      line-height: 24px;
      font-size: 1rem;
    }

    .sample-img {
      width: 100%;
      border-radius: 10px;
      margin-bottom: 10px;
    }
  }
</style>
